var map = {
	"./access-denied/access-denied.module": [
		"../../../../../src/app/access-denied/access-denied.module.ts",
		"access-denied.module"
	],
	"./app-user/app-user.module": [
		"../../../../../src/app/layout/app-user/app-user.module.ts",
		"common",
		"app-user.module"
	],
	"./appointment/appointment.module": [
		"../../../../../src/app/layout/appointment/appointment.module.ts",
		"common",
		"appointment.module"
	],
	"./change-password/change-password.module": [
		"../../../../../src/app/layout/change-password/change-password.module.ts",
		"common",
		"change-password.module"
	],
	"./check-in/check-in.module": [
		"../../../../../src/app/layout/check-in/check-in.module.ts",
		"common",
		"check-in.module"
	],
	"./dashboard/dashboard.module": [
		"../../../../../src/app/layout/dashboard/dashboard.module.ts",
		"common",
		"dashboard.module"
	],
	"./dnd/dnd1.module": [
		"../../../../../src/app/layout/dnd/dnd1.module.ts",
		"common",
		"dnd1.module"
	],
	"./forgot-password/forgot-pass.module": [
		"../../../../../src/app/forgot-password/forgot-pass.module.ts",
		"common",
		"forgot-pass.module"
	],
	"./form/appointmentform.module": [
		"../../../../../src/app/layout/appointment/form/appointmentform.module.ts",
		"common",
		"appointmentform.module"
	],
	"./form/categoryform.module": [
		"../../../../../src/app/layout/servicecategory/form/categoryform.module.ts",
		"common",
		"categoryform.module"
	],
	"./form/itemform.module": [
		"../../../../../src/app/layout/serviceitem/form/itemform.module.ts",
		"common",
		"itemform.module"
	],
	"./form/locationform.module": [
		"../../../../../src/app/layout/location/form/locationform.module.ts",
		"common",
		"locationform.module"
	],
	"./form/serviceform.module": [
		"../../../../../src/app/layout/service/form/serviceform.module.ts",
		"common",
		"serviceform.module"
	],
	"./itemord/itemordlist.module": [
		"../../../../../src/app/layout/serviceitem/itemord/itemordlist.module.ts",
		"common",
		"itemordlist.module"
	],
	"./layout/layout.module": [
		"../../../../../src/app/layout/layout.module.ts",
		"common",
		"layout.module"
	],
	"./list/appointmentlist.module": [
		"../../../../../src/app/layout/appointment/list/appointmentlist.module.ts",
		"common",
		"appointmentlist.module"
	],
	"./list/categorylist.module": [
		"../../../../../src/app/layout/servicecategory/list/categorylist.module.ts",
		"common",
		"categorylist.module"
	],
	"./list/dndlist.module": [
		"../../../../../src/app/layout/dnd/list/dndlist.module.ts",
		"common",
		"dndlist.module"
	],
	"./list/itemlist.module": [
		"../../../../../src/app/layout/serviceitem/list/itemlist.module.ts",
		"common",
		"itemlist.module"
	],
	"./list/locationlist.module": [
		"../../../../../src/app/layout/location/list/locationlist.module.ts",
		"common",
		"locationlist.module"
	],
	"./list/servicelist.module": [
		"../../../../../src/app/layout/service/list/servicelist.module.ts",
		"common",
		"servicelist.module"
	],
	"./list/veloxlocationlist.module": [
		"../../../../../src/app/layout/veloxlocation/list/veloxlocationlist.module.ts",
		"common",
		"veloxlocationlist.module"
	],
	"./location/location.module": [
		"../../../../../src/app/layout/location/location.module.ts",
		"common",
		"location.module"
	],
	"./login/login.module": [
		"../../../../../src/app/login/login.module.ts",
		"common",
		"login.module"
	],
	"./not-found/not-found.module": [
		"../../../../../src/app/not-found/not-found.module.ts",
		"not-found.module"
	],
	"./order/order.module": [
		"../../../../../src/app/layout/order/order.module.ts",
		"common",
		"order.module"
	],
	"./procedure/procedure.module": [
		"../../../../../src/app/layout/procedure/procedure.module.ts",
		"common",
		"procedure.module"
	],
	"./reset-password/reset-pass.module": [
		"../../../../../src/app/reset-password/reset-pass.module.ts",
		"common",
		"reset-pass.module"
	],
	"./server-error/server-error.module": [
		"../../../../../src/app/server-error/server-error.module.ts",
		"server-error.module"
	],
	"./service/service.module": [
		"../../../../../src/app/layout/service/service.module.ts",
		"common",
		"service.module"
	],
	"./servicecategory/category.module": [
		"../../../../../src/app/layout/servicecategory/category.module.ts",
		"common",
		"category.module"
	],
	"./serviceitem/item.module": [
		"../../../../../src/app/layout/serviceitem/item.module.ts",
		"common",
		"item.module"
	],
	"./signup/signup.module": [
		"../../../../../src/app/signup/signup.module.ts",
		"common",
		"signup.module"
	],
	"./user/user.module": [
		"../../../../../src/app/layout/user/user.module.ts",
		"common",
		"user.module"
	],
	"./veloxlocation/veloxlocation.module": [
		"../../../../../src/app/layout/veloxlocation/veloxlocation.module.ts",
		"common",
		"veloxlocation.module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "../../../../../src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src2455195120/src/src/$$_lazy_route_resource lazy
// module id = ../../../../../src/$$_lazy_route_resource lazy recursive
// module chunks = main